// extracted by mini-css-extract-plugin
module.exports = {"row":"Accounts_row___Lho3","main":"Accounts_main__vJgmz","details":"Accounts_details__NuEso","payouts":"Accounts_payouts__zLv97","col":"Accounts_col__ZqpBc"};